import { c as _c } from "react/compiler-runtime";
import { DirectionRightIcon, PasswordIcon, ShowPasswordIcon } from "@/app/components/UI/Icons";
import IInput from "@/app/components/Common/Input";
import registerContent from "@/app/components/auth/registerContent";
import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import Button from "@/app/components/UI/Button";
import checkPasswordFormat from "@/app/utils/checkPasswordFormat";
import toast from "react-hot-toast";
import { persianPattern } from "@/app/utils/Constants";
import cn from "@/app/utils/cn";
import { PasswordFormInterface } from "@/app/components/auth/Forms/passwordForm/passwordFormInterface";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { localeDirClient } from "@/app/utils/locale";
export default function PasswordForm(props) {
  const $ = _c(63);
  const t = useTranslations();
  const [password, setPassword] = useState("");
  const [passwordType, setPasswordType] = useState("password");
  const loginPendingRef = useRef(false);
  let t0;
  if ($[0] !== t) {
    t0 = function passwordChange(e) {
      const value = e.target.value;
      if (persianPattern.test(value)) {
        toast.error(t("auth.ENTER_ENGLISH_LETTERS"));
        return;
      }
      setPassword(value);
    };
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const passwordChange = t0;
  let t1;
  if ($[2] !== password || $[3] !== props) {
    t1 = function loginFunc(event) {
      event.preventDefault();
      if (props.passwordStates.isLoading || loginPendingRef.current) {
        return;
      }
      loginPendingRef.current = true;
      props.confirmFunction(props.mobile, password);
    };
    $[2] = password;
    $[3] = props;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const loginFunc = t1;
  let t2;
  let t3;
  if ($[5] !== props.passwordStates.hasError) {
    t2 = () => {
      if (props.passwordStates.hasError) {
        loginPendingRef.current = false;
      }
    };
    t3 = [props.passwordStates.hasError];
    $[5] = props.passwordStates.hasError;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className={cn(localeDirClient() === "ltr" ? "rotate-180" : "")}><DirectionRightIcon className="w-6 h-6" /></div>;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== props.backFunc) {
    t5 = <div className="md:hidden"><div className="mt-20 cursor-pointer" onClick={props.backFunc}>{t4}</div></div>;
    $[9] = props.backFunc;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("auth.PASSWORD");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <h1 className="text-base md:text-2xl font-bold">{t6}</h1>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("auth.PASSWORD_TEXT");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = <p className="text-charcoal-600 text-sm mt-4">{t8}</p>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7 || $[20] !== t9) {
    t10 = <div className="mt-6 mb-8">{t7}{t9}</div>;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t(registerContent.password);
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const t12 = props.passwordStates.hasError ? "\u06A9\u0644\u0645\u0647 \u0639\u0628\u0648\u0631 \u0648\u0627\u0631\u062F \u0634\u062F\u0647 \u0635\u062D\u06CC\u062D \u0646\u0645\u06CC\u200C\u0628\u0627\u0634\u062F." : "";
  const t13 = props.passwordStates.hasError ? "secondaryOutlineError" : "secondaryOutline";
  let t14;
  if ($[24] !== password || $[25] !== passwordChange || $[26] !== passwordType || $[27] !== t11 || $[28] !== t12 || $[29] !== t13) {
    t14 = <IInput inputId="password" label={t11} type={passwordType} value={password} onChange={passwordChange} autoFocus={true} helper={t12} helperClass="text-rojo-400 text-xs" style={t13} />;
    $[24] = password;
    $[25] = passwordChange;
    $[26] = passwordType;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== passwordType) {
    t15 = <div className="absolute top-10 end-2 cursor-pointer" onClick={() => setPasswordType(passwordType == "password" ? "text" : "password")}>{passwordType == "password" ? <PasswordIcon className="w-6 h-6" /> : <ShowPasswordIcon className="w-6 h-6" />}</div>;
    $[31] = passwordType;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t) {
    t16 = t("auth.FORGOT_PASSWORD");
    $[33] = t;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t16) {
    t17 = <div className="mt-4"><Link href="/forgotPassword" className="text-sm font-semibold text-bluetiful-400">{t16}</Link></div>;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t14 || $[38] !== t15 || $[39] !== t17) {
    t18 = <div className="mt-10 relative items-center">{t14}{t15}{t17}</div>;
    $[37] = t14;
    $[38] = t15;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  const t19 = props.passwordStates.isLoading;
  let t20;
  if ($[41] !== password || $[42] !== props.passwordStates.isDone || $[43] !== props.passwordStates.isLoading) {
    t20 = !password || Object.values(checkPasswordFormat(password)).includes(false) || props.passwordStates.isLoading || props.passwordStates.isDone;
    $[41] = password;
    $[42] = props.passwordStates.isDone;
    $[43] = props.passwordStates.isLoading;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t) {
    t21 = t(registerContent.loginText);
    $[45] = t;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t21) {
    t22 = <span className="text-center">{t21} </span>;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== loginFunc || $[50] !== props.passwordStates.isLoading || $[51] !== t20 || $[52] !== t22) {
    t23 = <div className="mt-4 w-full"><Button type="submit" fullWidth={true} loading={t19} disabled={t20} onClick={loginFunc}>{t22}</Button></div>;
    $[49] = loginFunc;
    $[50] = props.passwordStates.isLoading;
    $[51] = t20;
    $[52] = t22;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== t18 || $[55] !== t23) {
    t24 = <form autoComplete="on">{t18}{t23}</form>;
    $[54] = t18;
    $[55] = t23;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] !== t10 || $[58] !== t24) {
    t25 = <div className="relative">{t10}{t24}</div>;
    $[57] = t10;
    $[58] = t24;
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  let t26;
  if ($[60] !== t25 || $[61] !== t5) {
    t26 = <>{t5}{t25}</>;
    $[60] = t25;
    $[61] = t5;
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  return t26;
}